import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Dashboard from '../components/Menu/Dashboard';
import LoadingScreen from '../components/Complements/LoadingScreen';
import { Checkbox, CircularProgress, Fab, FormControl, FormControlLabel, Grid, Icon, InputLabel, MenuItem, Select, ListItem, ListItemText, ListItemAvatar, Avatar, List, Typography, Button, TextField, Card, CardContent, ListItemSecondaryAction, Tooltip } from '@material-ui/core';
import Title from '../components/Complements/Title';
import { feathersCreateData, feathersFindDataAll } from '../services';
import moment from 'moment'
import SelectForm from '../components/Complements/SelectForm';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import { history } from '../helpers/history';
import { Tbody, Td, Th, Thead, Tr, Table } from 'react-super-responsive-table';
import { Alert, Pagination } from '@material-ui/lab';
import { filterArrayEqual, isEmpty } from '../functions/arrays';
import StandardDialog from '../components/Complements/StandardDialog';
import DialogOTP from '../components/Complements/DialogOTP';
import { decrypt, encrypt } from '../functions/mobile';
import { isMobile } from 'react-device-detect';
import { urlVoucher } from '../services/urls';
import { handleDownloadMovil, handleDownloadWeb } from '../functions/handle-download';


const TransactionsActivityContainer = props => {
    const { company, classes, states, handleOpenSnack, user, devices } = props
    const [dateValue, setDateValue] = useState(JSON.stringify({ month: moment().month(), year: moment().year() }))
    const [loading, setLoading] = useState(false)
    const [accountSelected, setAccountSelected] = useState(company[0])
    const [dateStart, setDateStart] = useState(new Date(moment().startOf('month')))
    const [dateEnd, setDateEnd] = useState(new Date(moment().endOf('month')))
    const [payrollspaginate, setPayrollsPaginate] = useState([])
    const [payrollsTray, setPayrollsTray] = useState([])
    const [page, setPage] = useState(1)
    const [count, setCount] = useState(1)
    const [filters, setFilters] = useState({ approve: true, earring: true, timeOut: true, invalid: true, reject: true })
    const [dialog, setDialog] = useState({ open: false, title: '', content: <div></div> });
    const [observationValue, setObservationValue] = useState('');
    const [openDialogOTP, setOpenDialogOTP] = useState(false);
    const [initialTime, setInitialTime] = useState(Date.now());
    const [stateTransaction, setStateTransaction] = useState(1);


    const mount = () => {
        const unmount = () => {
            handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1)
        }
        return unmount()
    }
    useEffect(mount, [])
    const getDataViewTable = (total, numberpage) => {
        let contador = parseInt((total / 10).toString());
        let residuo = total % 10;
        if (residuo > 0) {
            contador++;
        }
        setCount(contador)
        setPage(numberpage)
    }
    const handleGetDataMovementsBySecuencialAccount = (rows, valuedateStart, valuedateEnd, numberpage) => {
        try {
            setLoading(true)

            feathersFindDataAll('transactions-tray', {
                company: company.id,
                createdAt: { $lte: valuedateEnd, $gte: valuedateStart }
            })().then(result => {
                const res1 = convertJsonToData(result)

                const res = res1.filter(r => r.validators.length)
                console.log(res);

                setPayrollsPaginate(res)
                setPayrollsTray(res)
                setLoading(false)
                getDataViewTable(res.length, numberpage);
            }).catch(err => {
                setLoading(false)
            })
        } catch (error) {
            setLoading(false)
        }
    }

    const convertJsonToData = (data) => {
        data.forEach(row => {
            try {
                row.body = JSON.parse(row.body);

            } catch (error) {
                console.log(error)
            }
        })

        return data
    }
    const handleSelectCode = (val) => {
        setDateValue(val)
        setLoading(true)
        if (val === 'Todos los movimientos') {
            setLoading(false)
        } else {
            let obj = JSON.parse(val)
            let selectMonth = new Date(obj.year, obj.month, 1)
            setDateStart(moment(selectMonth).startOf('month'))
            setDateEnd(moment(selectMonth).endOf('month'))
            //filterCodesByDate(dateStart, dateEnd, allcodes)
            setDateValue(val)
            setLoading(false)
            handleGetDataMovementsBySecuencialAccount(0, new Date(moment(selectMonth).startOf('month')), new Date(moment(selectMonth).endOf('month')), 1)
        }

    }
    const handleSetObservation = (value) => {
        setObservationValue(value)
    }
    const aprobeTransactionTray = (row) => {
        setStateTransaction(2)
        handleGenerateOtp({ action: 'INTERNAL_OTP', data: {}, row })
    }

    const handleGenerateOtp = async (data, state) => {

        setLoading(true)
        // setActionProcess(data.action)
        const { ip, device, mac } = devices

        const sendData = encrypt(JSON.stringify({ emited: 'NAVCREATECODE', type: 45, deviceData: device, ip, mac }))
        const responseGenerateCode = await feathersCreateData("codes-recovery", { sendData })()
        const { responseData } = responseGenerateCode
        const jsonDecrypt = JSON.parse(decrypt(responseData))

        const { type, alert } = jsonDecrypt;

        if (type === 'success') {
            // setPayrollerSelecter(data.row)
            setOpenDialogOTP(true)
            setInitialTime(Date.now())
            setLoading(false)
        } else {
            setLoading(false)
            handleOpenSnack(alert, type)
        }


    }
    const rejectTransactionTray = async (value) => {
        setStateTransaction(5)
        handleGenerateOtp()
    }
    const handleSubmit = (val) => {
        // console.log(val)
    }
    const handleDateStart = (date) => {
        setDateStart(date)
    }

    const handleDateEnd = (date) => {
        setDateEnd(date)
    }
    const handleFindRange = () => {
        if (!isEmpty(accountSelected)) {
            handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1)
        } else {
            handleOpenSnack('Seleccione una cuenta a buscar', 'error')
        }
    }
    const onChangePaginationPayroll = (e, numberpage) => {
        handleGetDataMovementsBySecuencialAccount((numberpage - 1) * 10, dateStart, dateEnd, numberpage);
    }
    const handleAccountFind = (value) => {
        setAccountSelected(value)
        handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1)
    }

    const handleCloseDialogOTP = () => {
        setOpenDialogOTP(false)
        //this.setState({ openDialogOTP: false })
    };

    const handleChangeInputOtp = (valueinput) => {
        //console.log(valueinput.target.value)
        if (valueinput.target.value.toString().length === 4) {
            receiveOTP({ data: valueinput.target.value.toString() });
        }

    }

    const receiveOTP = async (value) => {

        try {

            setLoading(true)

            const { data } = value
            const { ip, device, mac } = devices


            const sendData = encrypt(JSON.stringify({
                ip,
                mac,
                device,
                type: 45,
                inputOtp: data,

            }))

            const responseValidateCode = await feathersCreateData("code-validation", { sendData })()


            // const responseValidateCodeDecrypt = JSON.parse(decrypt(responseValidateCode.responseData))

            // console.log(responseValidateCodeDecrypt)

            const { error, message, type, viewDialogOtp } = responseValidateCode;

            if (error === false) {

                handleCloseDialogOTP()

                // proceso para hacer update
                let object_send = {
                    service: 'PROCESS_TRANSACTION',
                    observation: observationValue,//actionProcess === 'INTERNAL_OTP' ? dateValue : externalObservation,
                    otp: data,
                    state: stateTransaction,
                    ip,
                    mac,
                    device,
                    chanel: isMobile ? 'MOVIL' : 'WEB'

                }

                const response = await feathersCreateData("transactions-control", object_send)()

                setLoading(false)

                if (response.error) {
                    handleOpenSnack(response.message, 'error');
                } else {

                    // actionProcess === 'INTERNAL_OTP' && 
                    setDialog({ ...dialog, open: false })
                    handleOpenSnack(stateTransaction === 5 ? 'Transacción rechazada exitosamente' :'Transacción realizada exitosamente', 'success');
                    history.push('/')
                }


            } else {

                if (viewDialogOtp === false) {
                    handleCloseDialogOTP()
                }
                setLoading(false)
                props.handleOpenSnack(message, type);

            }

        } catch (error) {
            //console.log(error)
            setLoading(false)
            props.handleOpenSnack('Ha ocurrido un error al validar el código.', 'error');
        }

    }

    const handleDownloadVoucher = (fileName) => {
        if (localStorage.caja_app !== undefined) {
            // let send = {
            //     type: 'action',
            //     action: 'download_voucher',
            //     data: urlVoucher + fileName + ".pdf",
            //     messageSend: 'Comprobante'
            // }
            // sendMobile(JSON.stringify(send))
            handleDownloadMovil(urlVoucher, fileName)
            
        } else {
            // window.open(urlCertificates+nameFile+".pdf", '_blank');
            handleDownloadWeb(urlVoucher, fileName)
        }
    }

    const renderDetailValidator = (row) => {
        try {
            console.log(row);

            let destino;
            switch (row.body.type) {
                case 9:
                    destino = `${row.body.NombreApellido}`
                    break;
                case 18:
                    destino = `${row.body.NombreApellido}`
                    break;
                case 27:
                    destino = `${row.body.body.NombreInstitucion || ''} | Referencia: ${row.body.body.reference}`
                    break;
                case 29:
                    destino = `${row.body.body.NombreInstitucion || ''} | ${row.body.body.NombreDeudor} | Referencia: ${row.body.body.reference}`
                    break;

                default:
                    break;
            }
            return <div>
                <Grid container justify='center' key={row.id} style={{ marginBottom: 16 }}>
                    <Card variant='outlined'>
                        <CardContent>
                            <Grid xs={12} style={{ display: 'flex' }}>
                                <Grid xs={6} container direction='column' justify='center' alignItems='center' style={{ gap: 8 }}>
                                    <h1 style={{ fontSize: 70, lineHeight: 0, color: '#009fae' }}>{`$${row.amount}`}</h1>
                                    <span>
                                        {`${row.body.type === 9 ? 'TRANSFERENCIA INTERNA' : row.body.type === 18 ? 'TRANSFERENCIA EXTERNA' : row.body.type === 27 ? 'RECARGA ELECTRONICA' : 'PAGO DE SERVICIO'}`}
                                    </span>
                                    <span style={{ padding: 2, borderRadius: 4, backgroundColor: row.estado.color }}>{`${row.estado.name}`}</span>
                                </Grid>
                                <Grid xs={6} container direction='column' justify='center' style={{ paddingLeft: 16 }} >
                                    <b>{`Descripción: `}</b>{`${row.body.Detalle} `}
                                    <hr />
                                    <b>{`Solicitante: `}</b>{`${row.solicitante.vusk} - ${row.solicitante.customer.first_name || ' '} ${row.solicitante.customer.surname || ' '}`}
                                    <hr />
                                    <b>{`Destino: `}</b>{destino}
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>

                <List>
                    {row.validators.length && row.validators.map(v => <ListItem  >
                        <ListItemAvatar>
                            <Avatar>
                                <Icon>account_circle</Icon>
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={
                            <Typography >
                                <b>{`Autorizador: `}</b>{`${JSON.parse(v.body).name}`}
                                <br />
                                <b>Estado: </b> {`${v.estado.name}`}
                                <br />
                            </Typography>
                        } secondary={
                            (row.state === 1 && (v.cedule === user.vusk && v.state === 1)) &&
                            <Grid>
                                <Grid item xs={12} md={12} lg={12} sm={12}>
                                    <TextField
                                        margin="normal"
                                        fullWidth
                                        name={'Concepto'}
                                        inputProps={
                                            { style: { 'textTransform': 'uppercase' } }
                                        }
                                        label={'Observacion'}
                                        onChange={(ev) => {
                                            handleSetObservation(ev.target.value.toUpperCase())
                                        }}
                                    />
                                </Grid>


                                <Grid container spacing={3} >
                                    <Grid item xs={12} md={12} lg={6} sm={12}>

                                        <Button
                                            color="primary"
                                            variant="contained"
                                            onClick={() => aprobeTransactionTray(row)}
                                        >

                                            Aprobar
                                        </Button>
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            onClick={() => rejectTransactionTray(row)} >

                                            Rechazar
                                        </Button>


                                    </Grid>
                                </Grid>
                            </Grid>
                        } />

                    </ListItem>)}
                </List>

            </div>

        } catch (error) {
            console.log('error???', error);

        }

    }
    const handleOpenListDialog = (validators) => {

        try {
            setDialog({
                open: true, title: 'DETALLE',
                content: <>
                    {renderDetailValidator(validators)}

                </>

            })
        } catch (error) {
            console.log(error)
        }
    }
    const handleOpenListEmployees = (arrayErrors, type) => {
        console.log(arrayErrors, type);
        try {
            const errObject = JSON.parse(arrayErrors)
            setDialog({
                open: true, title: 'DETALLE DE TRANSFERENCIA',
                content:
                    <List >
                        <ListItem  >
                            <ListItemAvatar>
                                <Avatar>
                                    <Icon>account_circle</Icon>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={<><b>{`Destino: `}</b>{`${(type === 29 || type === 27) ? errObject.NombreInstitucion : errObject.Beneficiario ? errObject.Beneficiario : ''} `}</>}
                                secondary={
                                    <div>
                                        <b>{`Monto: `}</b>{`$${type === 29 ? errObject.MontoPagar : errObject.Monto} `}
                                        <br />
                                        <b>{(type === 29 || type === 27) ? 'Referencia: ' : '# Cuenta: '}</b>{`${type === 29 ? errObject.NumeroDeReferencia : type === 27 ? errObject.NumeroDeReferencia : errObject.NumeroCuentaDestino} `}
                                        <br />
                                        {
                                            errObject.error ?
                                                <span><b style={{ color: 'red' }}>{`ERROR DE TRANSFERENCIA: `}</b>{`${errObject.message.toUpperCase()}`} </span> :
                                                <b style={{ color: '#6fac22' }}>Transacción exitosa</b>
                                        }
                                    </div>
                                } />
                            {!errObject.error && <ListItemSecondaryAction>
                                <Button variant='contained' color='primary' onClick={() => handleDownloadVoucher(errObject.fileName)} >
                                    Descargar comprobante
                                </Button>
                            </ListItemSecondaryAction>}
                        </ListItem>
                    </List>
            })
        } catch (error) {
            console.log(error)
        }
    }
    const renderTableMovements = () => {
        if (loading) {
            return <CircularProgress />
        } else {
            if (payrollspaginate.length > 0) {
                return <div>
                    <Grid item xs={12} md={12} lg={12}>
                        <Table>
                            <Thead>
                                <Tr>
                                    <Th>Fecha</Th>
                                    <Th>Detalle</Th>
                                    <Th>Tipo</Th>
                                    <Th>Total</Th>
                                    <Th>Estado</Th>
                                    <Th>Accion</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {
                                    payrollspaginate.map(row => (
                                        <Tr key={`${row.id}`} style={{ textAlign: 'center' }}>
                                            <Td>{moment(row.createdAt).format('DD/MM/YYYY HH:mm')}</Td>
                                            <Td>{row.detail}</Td>
                                            {/* <Td>{accountSelected.pay_type}</Td> */}
                                            <Td>{row.body.type === 29 ? 'PAGO DE SERVICIO' : row.body.type === 27 ? 'RECARGA ELECTRONICA' : row.body.type === 9 ? 'TRANSFERENCIA INTERNA' : 'TRANSFERENCIA EXTERNA'}</Td>
                                            <Td>$ {parseFloat(row.amount).toFixed(2)}</Td>
                                            <Td style={{ color: row.state !== undefined ? filterArrayEqual(states, 'id', row.state)[0].color : '#FFFFFF', fontWeight: 'bold' }}>{row.state !== undefined ? filterArrayEqual(states, 'id', row.state)[0].name : ''}</Td>
                                            <Td>
                                                <Tooltip
                                                    arrow
                                                    title={'Aprobadores'}
                                                >
                                                    <Fab size="small" color="primary" aria-label="add" onClick={() => handleOpenListDialog(row)} >
                                                        <Icon>search</Icon>
                                                    </Fab>
                                                </Tooltip>
                                                {((row.state === 2 || row.state === 7) && row.responseCore !== null) &&
                                                    <Tooltip
                                                        arrow
                                                        title={'Comprobante'}
                                                    >
                                                        <Fab size="small" color="primary" aria-label="add" onClick={() => handleOpenListEmployees(row.responseCore, row.body.type)} >
                                                            <Icon>description</Icon>
                                                        </Fab>
                                                    </Tooltip>
                                                }
                                            </Td>
                                        </Tr>
                                    ))
                                }
                            </Tbody>
                        </Table>
                        <Pagination
                            count={count}
                            color="primary"
                            page={page}
                            onChange={onChangePaginationPayroll}
                        />
                    </Grid>
                </div>
            } else {
                return <Alert severity="info">No se han encontrado transacciones en el mes seleccionado.</Alert>
            }
        }
    }

    const renderBody = () => {
        return <div>
            <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg={12} sm={12}>
                    <Title>Datos de Transacción</Title>
                </Grid>
                <Grid item xs={12} md={12} lg={12} sm={12}>
                    <SelectForm
                        name={'Período'}
                        label={'Seleccione período '}
                        // data = { [{ id: '1', name: 'data'}] }
                        classes={classes}
                        dateValue={dateValue}
                        onSelected={(val) => handleSelectCode(val)}
                        onSubmit={handleSubmit}
                    ></SelectForm>
                </Grid>
                <Grid item xs={12} md={12} lg={12} sm={12}>
                    <Grid container justify="center" spacing={3} alignItems="flex-end">
                        <Grid item md={4} sm={12} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                <KeyboardDatePicker
                                    autoOk
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    id="date-start"
                                    label="Fecha de inicio"
                                    value={dateStart}
                                    onChange={handleDateStart}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={4} sm={12} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                <KeyboardDatePicker
                                    autoOk
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    id="date-end"
                                    label="Fecha de fin"
                                    value={dateEnd}
                                    onChange={handleDateEnd}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={2} sm={6} xs={6}>
                            <Fab color="primary" style={{ backgroundColor: '#8EAB40' }} aria-label="add" onClick={handleFindRange} >
                                <Icon>search</Icon>
                            </Fab>
                        </Grid>
                        <Grid item md={2} sm={6} xs={6}>
                            <Fab color="primary" aria-label="add" onClick={() => history.push('/')} >
                                <Icon>close</Icon>
                            </Fab>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={2} sm={12} xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={filters.approve}
                                onChange={(e) => {
                                    if (!e.target.checked) {
                                        setPayrollsPaginate(payrollspaginate.filter(p => p.state !== 2))
                                    } else {
                                        setPayrollsPaginate([...payrollspaginate, ...payrollsTray.filter(p => p.state === 2)])
                                    }
                                    setFilters({ ...filters, approve: !filters.approve })

                                }}
                                name="checkedB"
                                color="primary"
                            />
                        }
                        label="Verificado"
                    />
                </Grid>
                <Grid item md={2} sm={12} xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={filters.earring}
                                onChange={(e) => {
                                    if (!e.target.checked) {
                                        setPayrollsPaginate(payrollspaginate.filter(p => p.state !== 1))
                                    } else {
                                        setPayrollsPaginate([...payrollspaginate, ...payrollsTray.filter(p => p.state === 1)])
                                    }
                                    setFilters({ ...filters, earring: !filters.earring })

                                }}
                                name="checkedB"
                                color="primary"
                            />
                        }
                        label="Pendientes"
                    />
                </Grid>
                <Grid item md={2} sm={12} xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={filters.timeOut}
                                onChange={(e) => {
                                    if (!e.target.checked) {
                                        setPayrollsPaginate(payrollspaginate.filter(p => p.state !== 3))
                                    } else {
                                        setPayrollsPaginate([...payrollspaginate, ...payrollsTray.filter(p => p.state === 3)])
                                    }
                                    setFilters({ ...filters, timeOut: !filters.timeOut })
                                }}
                                name="checkedB"
                                color="primary"
                            />
                        }
                        label="Caducados"
                    />
                </Grid>
                <Grid item md={2} sm={12} xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={filters.reject}
                                onChange={(e) => {
                                    if (!e.target.checked) {
                                        setPayrollsPaginate(payrollspaginate.filter(p => p.state !== 5))
                                    } else {
                                        setPayrollsPaginate([...payrollspaginate, ...payrollsTray.filter(p => p.state === 5)])
                                    }
                                    setFilters({ ...filters, reject: !filters.reject })

                                }}
                                name="checkedB"
                                color="primary"
                            />
                        }
                        label="Rechazado"
                    />
                </Grid>
                <Grid item md={3} sm={12} xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={filters.invalid}
                                onChange={(e) => {
                                    if (!e.target.checked) {
                                        setPayrollsPaginate(payrollspaginate.filter(p => p.state !== 4))
                                    } else {
                                        setPayrollsPaginate([...payrollspaginate, ...payrollsTray.filter(p => p.state === 4)])
                                    }
                                    setFilters({ ...filters, invalid: !filters.invalid })

                                }}
                                name="checkedB"
                                color="primary"
                            />
                        }
                        label="No válido "
                    />
                </Grid>
            </Grid>
            <Grid container spacing={3} justify="center" alignItems="center">
                <Grid item md={12} sm={12} xs={12}>
                    {renderTableMovements()}
                </Grid>
            </Grid>
        </div>
    }
    const renderHeader = () => {
        return <Grid container spacing={3} justify="center" alignItems="center">
            <Grid item md={12} sm={12} xs={12}>
                <FormControl variant="outlined" >
                    <InputLabel id="demo-simple-select-outlined-label">Seleccione una Cuenta</InputLabel>
                    <Select
                        label="Seleccione una Cuenta"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        defaultValue={company.length > 0 ? accountSelected : undefined}
                        onChange={(e) => handleAccountFind(e.target.value)}
                    >
                        {
                            company.map(option => {
                                return <MenuItem key={option.id} value={option}>{`${option.name} - ${option.number_account}`}</MenuItem>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    }
    return (
        <div>
            <Dashboard
                title="Dashboard"
                body={renderBody()}
                info={renderHeader()}
                multiple={true}
                panel={2}
            />
            <StandardDialog
                open={dialog.open}
                title={dialog.title}
                handleClose={() => setDialog({ ...dialog, open: false })} >
                {dialog.content}
            </StandardDialog>
            <DialogOTP
                openDialogOTP={openDialogOTP}
                loading={loading}
                initialTime={initialTime}
                showQR={false}
                onCloseDialogOTP={handleCloseDialogOTP}
                onKeyPress={handleChangeInputOtp}
                OTPSubmit={receiveOTP}
            />

            <LoadingScreen open={loading} />
        </div>
    );
};

TransactionsActivityContainer.propTypes = {
    company: PropTypes.array.isRequired,
};

export default TransactionsActivityContainer;